<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-navigation-drawer v-model="sidebarDrawer"
                         :clipped="$vuetify.breakpoint.lgAndUp" app
    >
        <v-list dense>

            <!-- Home -->
            <v-list-item to="/">
                <v-list-item-icon>
                    <v-icon>home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ $t("general.home") }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Working Hours List Group -->
            <v-list-group v-if="createWorkHours && viewWorkHours"
                          prepend-icon="access_time"
                          no-action
            >
                <template v-slot:activator>
                    <v-list-item-title>{{ $t("general.workHours") }}</v-list-item-title>
                </template>

                <!-- Create Hours -->
                <v-list-item v-if="createWorkHours"
                             to="/work-hours/create">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("workHours.create") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- View Hours -->
                <v-list-item v-if="viewWorkHours"
                             to="/work-hours/view">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("workHours.list") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list-group>

            <!-- Invoices -->
            <v-list-group v-if="createInvoices && viewInvoices"
                          prepend-icon="credit_card"
                          no-action
            >
                <template v-slot:activator>
                    <v-list-item-title>{{ $t('invoices.plural') }}</v-list-item-title>
                </template>

                <!-- Create Invoices -->
                <v-list-item v-if="createInvoices"
                             to="/invoices/create">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('invoices.create') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- View Invoices -->
                <v-list-item v-if="viewInvoices"
                             to="/invoices/view">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('invoices.list') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list-group>

            <!-- Settings -->
            <v-list-group v-if="manageSettings"
                          prepend-icon="settings_applications"
                          no-action
            >
                <template v-slot:activator>
                    <v-list-item-title>{{ $t("general.settings") }}</v-list-item-title>
                </template>

                <!-- Customers List -->
                <v-list-item to="/settings/app-settings">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("general.app_settings") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Customers List -->
                <v-list-item to="/settings/clients">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("settings.clientsList") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Projects List -->
                <v-list-item to="/settings/projects">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("settings.projectsList") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Users List -->
                <v-list-item to="/settings/users">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("settings.usersList") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Users List -->
                <v-list-item to="/settings/bank-accounts">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("bank_accounts.list") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list-group>
        </v-list>

        <template v-slot:append>
            <v-footer color="grey lighten-4">
                <v-spacer></v-spacer>
                <div>v {{ version }}</div>
            </v-footer>
        </template>
    </v-navigation-drawer>
</template>

<script>
    export default {
        props: {
            drawer: {
                type: Boolean
            }
        },
        data: () => ({
            sidebarDrawer: null,
            manageSettings: false,
            viewWorkHours: false,
            createWorkHours: false,
            viewInvoices: false,
            createInvoices: false,
            version: process.env.VUE_APP_VERSION
        }),
        async mounted() {
            // Get permissions
            this.manageSettings = await this.$store.dispatch('userHasPermission', 'manage_settings');
            this.viewWorkHours = await this.$store.dispatch('userHasPermission', 'view_work_hours');
            this.createWorkHours = await this.$store.dispatch('userHasPermission', 'create_work_hours');
            this.viewInvoices = await this.$store.dispatch('userHasPermission', 'view_invoices');
            this.createInvoices = await this.$store.dispatch('userHasPermission', 'create_invoices');
        },
        watch: {
            drawer(val) {
                this.sidebarDrawer = val;
            }
        }
    }
</script>